<template lang="pug">
v-breadcrumbs(
  :items="designedItems"
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
  template(#divider)
    v-icon(size="16" color="ui-neutral") {{ dividerIcon }}
  template(#item="{ item }")
    v-breadcrumbs-item(
      v-bind="item"
    ) {{ item.text }}
</template>

<script>
import { VBreadcrumbs, VBreadcrumbsItem } from 'vuetify/lib';

export default {
  components:  { VBreadcrumbs, VBreadcrumbsItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    dividerIcon: {
      type: [Object, Function, String],
      default: '$ui-chevron-right',
    },
    itemAttrs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      return {
        class: [
          'dv-breadcrumbs',
          'pa-0',
        ],
        ...this.$attrs,
      };
    },
    designedItems() {
      return this.items.map((item, idx, items) => ({
        ...item,
        ...this.itemAttrs,
        class: [
          'ui-body-2',
          'ui-neutral--text',
          ...(idx !== (items?.length - 1)) ? ['text--lighten-2'] : [],
          ...[this.itemAttrs?.class].flat(),
        ].filter(Boolean).join(' '),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
